import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  template: `
    <h2 mat-dialog-title>
      {{
        'LISTS.CAMPAIGN_DIALOG.ADD_LIST_TO_CAMPAIGN_TITLE'
          | translate: { campaignName: campaignName, listName: actionListName }
      }}
    </h2>
    <mat-dialog-content>
      <p>
        {{ 'LISTS.CAMPAIGN_DIALOG.ADDED_LIST_TO_CAMPAIGN_TEXT' | translate }}
      </p>
      <div></div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button matDialogClose>{{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}</button>
      <button mat-raised-button color="primary" (click)="viewProgress()">
        {{ 'LISTS.CAMPAIGN_DIALOG.VIEW_LIST_PROGRESS' | translate }}
      </button>
    </mat-dialog-actions>
  `,
})
export class ViewActionListHistoryDialogComponent {
  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<ViewActionListHistoryDialogComponent>,
  ) {}

  @Input()
  actionListName: string;
  @Input()
  campaignName: string;
  @Input()
  actionListId: string;

  viewProgress(): void {
    this.router.navigate(['action-lists', this.actionListId, 'history']);
    this.dialogRef.close();
  }
}
